import ModalComponent from '../../../../components/ModalComponent';
import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  IDefenseEventDoorAccessCaptureFingerPrintProps,
  IDefenseEventDoorAccessStatusProps,
  IDefenseEventDoorAlwaysOpenCloseStatusProps,
  IDefenseEventDoorGlobalControlStatusProps,
  IDefenseEventHandleAlarmProps,
  IDefenseEventNotifyAccessProps,
  IDefenseEventNotifyAddUpdateVisitorProps,
  IDefenseEventNotifyAlarmPictureProps,
  IDefenseEventNotifyAlarmProps,
  IDefenseEventNotifyAreaArmStatusProps,
  IDefenseEventNotifyDeviceChannelStatusProps,
  IDefenseEventNotifyDeviceStatusProps,
  IDefenseEventNotifyFacesProps,
  IDefenseEventNotifyHumanProps,
  IDefenseEventNotifyMotorVehicleProps,
  IDefenseEventNotifyNonMotorVehicleProps,
  IDefenseEventNotifySyncDeviceProps,
  IDefenseEventNotifyVehicleCaptureProps,
  IDefenseEventNotifyVisitorCountReportProps,
  IDefenseEventNotifyZoneByPassStatusProps,
  IDefenseEventNotifyZoneFaultStatusProps,
  IDefenseEventOpenSluiceProps,
  IDefenseEventProps,
} from '../../../../services/Defense/Events/types';
import { useDefenseEventByIdAsync } from '../../../../services/Defense/Events/hooks/useMutations';
import { AppContext } from '../../../../context/AppContextProvider';
import DefenseNotifyDeviceStatusContent from './DefenseNotifyDeviceStatusContent';
import DefenseNotifyDeviceChannelStatusContent from './DefenseNotifyDeviceChannelStatusContent';
import DefenseHandleAlarmContent from './DefenseHandleAlarmContent';
import DefenseNotifyAlarmContent from './DefenseNotifyAlarmContent';
import DefenseNotifyAlarmPictureContent from './DefenseNotifyAlarmPictureContent';
import DefenseDoorAccessStatusContent from './DefenseDoorAccessStatusContent';
import DefenseDoorGlobalControlStatusContent from './DefenseDoorGlobalControlStatusContent';
import DefenseDoorAlwaysOpenCloseStatusContent from './DefenseDoorAlwaysOpenCloseStatusContent';
import DefenseNotifyFaceInfosContent from './DefenseNotifyFaceInfosContent';
import DefenseOpenSluiceContent from './DefenseOpenSluiceContent';
import DefenseNotifyAccessContent from './DefenseNotifyAccessContent';
import DefenseDoorAccessCaptureFingerPrintContent from './DefenseDoorAccessCaptureFingerPrintContent';
import DefenseNotifyAddUpdateVisitorContent from './DefenseNotifyAddUpdateVisitorContent';
import DefenseNotifyDeleteVisitorContent from './DefenseNotifyDeleteVisitorContent';
import DefenseNotifyVisitorReportCountContent from './DefenseNotifyVisitorReportCountContent';
import DefensePersonContent from './DefensePersonContent';
import DefenseNotifyVehicleCaptureInfosContent from './DefenseNotifyVehicleCaptureInfosContent';
import DefenseNotifyHumanInfosContent from './DefenseNotifyHumanInfosContent';
import DefenseNotifyMotorVehicleContent from './DefenseNotifyMotorVehicleContent';
import DefenseNotifyNoMotorVehicleInfosContent from './DefenseNotifyNoMotorVehicleInfosContent';
import DefenseNotifyAreaArmStatusContent from './DefenseNotifyAreaArmStatusContent';
import DefenseNotifyZonesByPassStatusContent from './DefenseNotifyZonesByPassStatusContent';
import DefenseNotifyZoneFaultStatusContent from './DefenseNotifyZoneFaultStatusContent';
import DefenseNotifySyncDeviceContent from './DefenseNotifySyncDeviceContent';

interface IDefenseEventDetailsModalProps {
  isOpen: boolean;
  selectedEvent?: IDefenseEventProps;
  setSelectedEvent?: Dispatch<SetStateAction<any>>;
  onClose?: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const DefenseEventDetailsModal = ({
  isOpen,
  selectedEvent,
  setSelectedEvent,
  setIsOpen,
}: IDefenseEventDetailsModalProps) => {
  const { showSnackbar } = useContext(AppContext);
  const [event, setEvent] = useState<IDefenseEventProps>();
  const [eventContent, setEventContent] = useState<ReactNode>();

  const { mutate: getEvents } = useDefenseEventByIdAsync();

  const handleClose = () => {
    setIsOpen(false);
    setEventContent(undefined);
    setEvent(undefined);
    if (setSelectedEvent) setSelectedEvent(undefined);
  };

  const getModalContent = (type: string) => {
    switch (type) {
      case 'DEFENSE_NOTIFY_DEVICE_STATUS':
        return (
          <DefenseNotifyDeviceStatusContent
            event={event as IDefenseEventNotifyDeviceStatusProps}
          />
        );

      case 'DEFENSE_NOTIFY_DEVICE_CHANNEL_STATUS':
        return (
          <DefenseNotifyDeviceChannelStatusContent
            event={event as IDefenseEventNotifyDeviceChannelStatusProps}
          />
        );

      case 'DEFENSE_HANDLE_ALARM':
        return (
          <DefenseHandleAlarmContent
            event={event as IDefenseEventHandleAlarmProps}
          />
        );

      case 'DEFENSE_NOTIFY_ALARM_PICTURE':
        return (
          <DefenseNotifyAlarmPictureContent
            event={event as IDefenseEventNotifyAlarmPictureProps}
          />
        );

      case 'DEFENSE_DOOR_ACCESS_STATUS':
        return (
          <DefenseDoorAccessStatusContent
            event={event as IDefenseEventDoorAccessStatusProps}
          />
        );

      case 'DEFENSE_DOOR_GLOBAL_CONTROL_STATUS':
        return (
          <DefenseDoorGlobalControlStatusContent
            event={event as IDefenseEventDoorGlobalControlStatusProps}
          />
        );

      case 'DEFENSE_DOOR_ALWAYS_OPEN_CLOSE_STATUS':
        return (
          <DefenseDoorAlwaysOpenCloseStatusContent
            event={event as IDefenseEventDoorAlwaysOpenCloseStatusProps}
          />
        );

      case 'DEFENSE_ADD_PERSON':
        return <DefensePersonContent event={event!} />;

      case 'DEFENSE_UPDATE_PERSON':
        return <DefensePersonContent event={event!} />;

      case 'DEFENSE_DELETE_PERSON':
        return <DefensePersonContent event={event!} />;

      case 'DEFENSE_DOOR_ACCESS_CAPTURE_FINGER_PRINT':
        return (
          <DefenseDoorAccessCaptureFingerPrintContent
            event={event as IDefenseEventDoorAccessCaptureFingerPrintProps}
          />
        );

      case 'DEFENSE_NOTIFY_ACS_EVENT':
        return (
          <DefenseNotifyAccessContent
            event={event as IDefenseEventNotifyAccessProps}
          />
        );

      case 'DEFENSE_OPEN_SLUICE':
        return (
          <DefenseOpenSluiceContent
            event={event as IDefenseEventOpenSluiceProps}
          />
        );

      case 'DEFENSE_NOTIFY_ALARMS':
        return (
          <DefenseNotifyAlarmContent
            event={event as IDefenseEventNotifyAlarmProps}
          />
        );

      case 'DEFENSE_NOTIFY_ADD_VISITOR':
        return (
          <DefenseNotifyAddUpdateVisitorContent
            event={event as IDefenseEventNotifyAddUpdateVisitorProps}
          />
        );

      case 'DEFENSE_NOTIFY_UPDATE_VISITOR':
        return (
          <DefenseNotifyAddUpdateVisitorContent
            event={event as IDefenseEventNotifyAddUpdateVisitorProps}
          />
        );

      case 'DEFENSE_NOTIFY_DELETE_VISITORS':
        return <DefenseNotifyDeleteVisitorContent event={event!} />;

      case 'DEFENSE_NOTIFY_VISITOR_COUNT_REPORT':
        return (
          <DefenseNotifyVisitorReportCountContent
            event={event as IDefenseEventNotifyVisitorCountReportProps}
          />
        );

      case 'DEFENSE_NOTIFY_VEHICLE_CAPTURE_INFO':
        return (
          <DefenseNotifyVehicleCaptureInfosContent
            event={event as IDefenseEventNotifyVehicleCaptureProps}
          />
        );

      case 'DEFENSE_NOTIFY_FACE_INFOS':
        return (
          <DefenseNotifyFaceInfosContent
            event={event as IDefenseEventNotifyFacesProps}
          />
        );

      case 'DEFENSE_NOTIFY_HUMAN_INFOS':
        return (
          <DefenseNotifyHumanInfosContent
            event={event as IDefenseEventNotifyHumanProps}
          />
        );

      case 'DEFENSE_NOTIFY_MOTOR_VEHICLE_INFOS':
        return (
          <DefenseNotifyMotorVehicleContent
            event={event as IDefenseEventNotifyMotorVehicleProps}
          />
        );

      case 'DEFENSE_NOTIFY_NO_MOTOR_VEHICLE_INFOS':
        return (
          <DefenseNotifyNoMotorVehicleInfosContent
            event={event as IDefenseEventNotifyNonMotorVehicleProps}
          />
        );

      case 'DEFENSE_NOTIFY_AREA_ARM_STATUS':
        return (
          <DefenseNotifyAreaArmStatusContent
            event={event as IDefenseEventNotifyAreaArmStatusProps}
          />
        );

      case 'DEFENSE_NOTIFY_ZONE_BY_PASS_STATUS':
        return (
          <DefenseNotifyZonesByPassStatusContent
            event={event as IDefenseEventNotifyZoneByPassStatusProps}
          />
        );

      case 'DEFENSE_NOTIFY_ZONE_FAULT_STATUS':
        return (
          <DefenseNotifyZoneFaultStatusContent
            event={event as IDefenseEventNotifyZoneFaultStatusProps}
          />
        );

      case 'DEFENSE_NOTIFY_SYNC_DEVICE_INFO':
        return (
          <DefenseNotifySyncDeviceContent
            event={event as IDefenseEventNotifySyncDeviceProps}
          />
        );

      default:
        throw new Error('Unsupported event');
    }
  };

  useEffect(() => {
    if (event && selectedEvent) {
      const componentContent = getModalContent(selectedEvent.type);
      setEventContent(componentContent);
    }
  }, [event]);

  useEffect(() => {
    if (selectedEvent) {
      getEvents(
        {
          id: selectedEvent.id,
          type: selectedEvent.type,
        },
        {
          onSuccess: (data) => {
            setEvent(data);
          },
          onError: (error: any) => showSnackbar(error, 'error'),
        },
      );
    }
  }, [selectedEvent]);

  return (
    <ModalComponent
      onClose={handleClose}
      isOpen={isOpen}
      title={'Detalhes do Evento'}
    >
      {eventContent}
    </ModalComponent>
  );
};

export default DefenseEventDetailsModal;
